// extracted by mini-css-extract-plugin
export var centerList = "_a2-7";
export var centerLoc = "_a2-b";
export var centerName = "_a2-a";
export var centerOptionBody = "_a2-9";
export var centerRow = "_a2-8";
export var centerStatus = "_a2-c";
export var empty = "_a2-6";
export var externalIcon = "_a2-d";
export var fieldCount = "_a2-4";
export var fieldHeader = "_a2-2";
export var fieldHelp = "_a2-5";
export var fieldLabel = "_a2-3";
export var panel = "_a2-0";
export var removeBtn = "_a2-e";
export var section = "_a2-1";